import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

import { Button } from '../../commons/utils';

const PlanogramImageStacking = ({ isOpen, close, cabinetSlotData, shelfNumber, allProducts, t }) => {
    const products = cabinetSlotData.products || [];

    return (
        <Modal isOpen={isOpen} centered={true} size="md" className="planogram__modal">
            <div className="planogram__modal-header">
                <label>{t('refill:shelf')}:</label>
                {shelfNumber} |<label>{t('slot')}: </label> {cabinetSlotData.slot}
            </div>
            <ModalBody className="planogram__modal-body">
                <div className="planogram__modal-direction planogram__modal-direction--back">
                    <span>{t('main:back')}</span>
                    <svg>
                        <use xlinkHref="#icon-arrow-right"></use>
                    </svg>
                    <span>{t('refill:front')}</span>
                </div>
                <div className="planogram__modal-images">
                    {products.map((id, index) => {
                        const selectedProduct = allProducts.find(product => product.id === id);
                        if (!selectedProduct.imageUrl) {
                            return (
                                <svg style={{ left: `${index * 60}px`, width: `${80 + index * 6}px`, height: `${80 + index * 6}px` }} key={id}>
                                    <use xlinkHref="#icon-cube"></use>
                                </svg>
                            );
                        } else {
                            return (
                                <img
                                    src={selectedProduct.imageUrl}
                                    alt=""
                                    style={{ left: `${index * 60}px`, width: `${80 + index * 6}px`, height: `${80 + index * 6}px` }}
                                    title={`${selectedProduct.name} ( ${selectedProduct.barcode} )`}
                                    key={id}
                                />
                            );
                        }
                    })}
                </div>
                <ul className="planogram__modal-names">
                    {products.map((id, index) => {
                        const selectedProduct = allProducts.find(product => product.id === id);
                        return (
                            <li key={`${id}-${index}`}>
                                {index + 1}. {selectedProduct.name}
                            </li>
                        );
                    })}
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button type="close" text={t('main:close')} onClick={() => close()} />
            </ModalFooter>
        </Modal>
    );
};

export default PlanogramImageStacking;
